// packages/client/src/app/theme/it2go.preset.ts
import Aura from '@openng/optimus-ui-themes/aura';
import { definePreset } from '@openng/optimus-ui-themes';

const it2goPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '{blue.50}', 100: '{blue.100}', 200: '{blue.200}', 300: '{blue.300}',
            400: '{blue.400}', 500: '{blue.500}', 600: '{blue.600}',
            700: '{blue.700}', 800: '{blue.800}', 900: '{blue.900}', 950: '{blue.950}',
        },
        focusRing: {
            width: '2px',
            style: 'solid',
            color: '{primary.color}',
            offset: '1px',
        },
        colorScheme: {
            light: {
                surface: {
                    ground: '{surface.50}',
                    overlay: '{surface.0}',
                    hover: '{surface.100}',
                    border: '{surface.200}',
                    shadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)',
                    breadcrumbBg: '{surface.100}',
                    textSecondary: '{surface.600}',
                },
                sidebar: {
                    bgColor: 'var(--p-gray-700)',
                    menuSeparatorBorder: '1px solid rgba(255, 255, 255, 0.2)',
                    menuitemTextColor: 'rgba(255, 255, 255, 0.2)',
                    menuitemHoverBg: 'rgba(255, 255, 255, 0.1)',
                    menuitemActiveBg: 'rgba(255, 255, 255, 0.1)',
                    menuitemTextActiveColor: '#ffffff',
                    menuitemFocusShadow: '0 0 0 0.2rem rgba(255, 255, 255, 0.1)',
                },
                table: {
                    maskBackground: 'rgba(0,0,0,0.05)',
                    rowBackground: 'var(--p-content-background)',
                    cellBorderColor: 'var(--p-content-border-color)',
                    selectedBackground: 'var(--p-highlight-background)',
                    selectedBorderColor: '{primary.100}',
                },
                border: {
                    radius: '8px',
                },
            },
            dark: {
                surface: {
                    ground: '{surface.950}',
                    overlay: '{surface.900}',
                    hover: '{surface.800}',
                    border: '{surface.700}',
                    shadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)',
                    breadcrumbBg: '{surface.800}',
                    textSecondary: '{surface.300}',
                },
                sidebar: {
                    bgColor: 'var(--p-content-surface-100)',
                    menuSeparatorBorder: '1px solid var(--p-surface-border)',
                    menuitemRootTextColor: 'var(--p-text-color-secondary)',
                    menuitemTextColor: 'var(--p-text-color)',
                    menuitemHoverBg: 'rgba(255, 255, 255, 0.05)',
                    menuitemActiveBg: 'var(--p-content-surface-300)',
                    menuitemTextActiveColor: 'var(--p-text-color)',
                    menuitemFocusShadow: '0 0 0 1px var(--p-content-surface-600)',
                },
                table: {
                    maskBackground: 'rgba(0,0,0,0.3)',
                    rowBackground: 'var(--p-content-background)',
                    cellBorderColor: 'var(--p-content-border-color)',
                    selectedBackground: 'var(--p-highlight-background)',
                    selectedBorderColor: '{primary.900}',
                },
                border: {
                    radius: '8px',
                },
            },
        },
    },
    components: {
        floatlabel: {
            root: {
                color: '{surface.600}',
                focusColor: '{primary.color}',
                activeColor: '{primary.color}',
            },
        },
        button: {
            colorScheme: {
                dark: {
                    outlined: {
                        contrast: {
                            hoverBackground: '{surface.700}',
                        },
                    },
                    text: {
                        contrast: {
                            hoverBackground: '{surface.700}',
                        },
                    },
                },
            },
        },
        togglebutton: {
            colorScheme: {
                light: {
                    root: {
                        borderColor: '{form.field.border.color}',
                        checkedBackground: '{primary.color}',
                        checkedBorderColor: '{primary.color}',
                        checkedColor: 'var(--p-button-primary-color)',
                    },
                    content: {
                        checkedBackground: '{primary.color}',
                    },
                    icon: {
                        checkedColor: 'var(--p-button-primary-color)',
                    },
                },
                dark: {
                    root: {
                        borderColor: '{form.field.border.color}',
                        checkedBackground: '{primary.color}',
                        checkedBorderColor: '{primary.color}',
                        checkedColor: 'var(--p-button-primary-color)',
                    },
                    content: {
                        checkedBackground: '{primary.color}',
                    },
                    icon: {
                        checkedColor: 'var(--p-button-primary-color)',
                    },
                },
            },
        },
        chip: {
            root: {
                paddingX: 'var(--app-general-spacing-small)',
                paddingY: '0',
            },
            colorScheme: {
                light: {
                    root: {
                        background: '{surface.300}',
                    },
                },
                dark: {
                    root: {
                        background: '{surface.700}',
                    },
                },
            },
        },
        popover: {
            content: {
                padding: '0',
            },
            root: {
                gutter: 'var(--app-general-spacing-small)',
                arrowOffset: 'var(--app-general-spacing-medium)',
            },
        },
        fileupload: {
            file: {
                padding: 'var(--app-general-spacing-xx-small)',
                info: {
                    gap: 'var(--app-general-spacing-xx-small)',
                },
            },
            progressbar: {
                height: 'var(--app-general-spacing-small)',
            },
        },
        dialog: {
            root: {
                background: 'var(--p-surface-ground)',
            },
        },
        splitter: {
            root: {
                background: 'var(--p-surface-ground)',
                borderColor: 'var(--p-surface-ground)',
            },
        },
    },
});

export default it2goPreset;
